import type { Event, EventHint } from '@sentry/vue';
import { AxiosError, isAxiosError, isCancel } from 'axios';

// Must return the event (or null to drop it): Sentry discards any other return value,
// which used to drop every frontend error that was not an AxiosError.
export function handleSentryBeforeSend<T extends Event>(event: T, hint?: EventHint): T | null {
  const error = hint?.originalException;
  // Requests apiClient deliberately did not send because the session had ended
  if (isCancel(error)) {
    return null;
  }
  return addAxiosContextRecursive(event, error);
}

function addAxiosContextRecursive<T extends Event>(event: T, error: unknown): T {
  if (isAxiosError(error)) {
    return addAxiosContext(event, error);
  } else if (error instanceof Error && error.cause) {
    return addAxiosContextRecursive(event, error.cause);
  }
  return event;
}

function addAxiosContext<T extends Event>(event: T, error: AxiosError): T {
  if (error.response) {
    const contexts = { ...event.contexts };
    contexts.Axios = { Response: error.response };
    event.contexts = contexts;
  }
  return event;
}
